<div class="progress-overlay">
	<div class="progress-indicator" tt>Loading...</div>
</div>
